import React from "react";
import NavBar from "../../Misc/NavBar";

export default function AppSidebarView() {
  return (
    <aside className={`app-sidebar`}>
      <NavBar />
    </aside>
  );
}
